import {
  ChangeAvatarRequest,
  ChangeAvatarResponse,
  HttpMethod,
} from '@aibees/shared/definition';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import axios from 'axios';
import { useUserProfileApi } from './use-user-profile-api';

export function useChangeProfileAvatarMutationApi() {
  return useBaseMutation<ChangeAvatarRequest, ChangeAvatarResponse>({
    url: '/customer-management/um/users/profile',
    params: {
      action: 'change-picture',
    },
    method: HttpMethod.patch,
  });
}

export function changeAvatarCallbackRequest(url: string, file: File) {
  return axios
    .put(url, file, {
      headers: {
        'Content-Type': 'image/jpeg',
        'x-amz-acl': 'public-read',
      },
    })
    .then(() => {
      baseQueryClient.invalidateQueries([useUserProfileApi.name]);
      return true;
    });
}
